import { ProfitAndLossMonthlyGraphData } from "@/types/profit-and-loss-monthly-graph-api";
import { api, withErrorHandling } from "./api";
import qs from "qs";

export const getProfitAndLossMonthlyGraph = async (
  clientId: string,
  connectionIds: string[],
  fromYear: number,
  fromMonth: number,
  toYear: number,
  toMonth: number
): Promise<ProfitAndLossMonthlyGraphData> => {
  const response = await withErrorHandling(() =>
    api.get(`/clients/${clientId}/report/profit-and-loss/monthly-graph`, {
      params: {
        clientId,
        fromYear,
        fromMonth,
        toYear,
        toMonth,
        connectionIds: connectionIds[0],
      },
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "repeat" }),
    })
  );
  return response.data;
};
